import API from '@/lib/API.js'
import comun from './comun.js'
const certificadosafiliados = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state = {
                Lista: [],
                Seleccionado: undefined
            };
        },
        set(state, valor) {
            state.Lista = valor;
        },
        agregar(state, valor) {
            state.Lista.push(valor);
        },
        select(state, valor) {
            state.Seleccionado = valor;
        },
    },
    actions: {
        async traerPorAfiliado({
            commit
        }, valor) {
            commit("comun/cargando")
            let data = []
            data = await API.Certificados_Afiliados.traerPorAfiliado(valor);
            commit("set", data)
            commit("comun/fincarga")
        },
        select({
            commit
        }, valor) {
            commit("select", valor)
            commit("set", [])
        },
        async modificarSeleccionada({
            commit,
            state
        }) {
            try {
                let data = []
                let str = ""
                if (state.Seleccionado.id_item != 0) {
                    data = await API.Certificados_Afiliados.modificar(state.Seleccionado);
                    str += "Certificado modificado"
                } else {
                    data = await API.Certificados_Afiliados.alta(state.Seleccionado);
                    commit("agregar", data)
                    str += `Certificado dado de alta`
                }
                commit("select", data)
                commit("comun/mostrar", str)

            } catch (error) {
                alert(error)
            }
        },
        async modificarEntidad({
            commit,
            state
        }, entidad) {
            try {
                let str = ""
                if (entidad.id_item != 0) {
                    entidad = await API.Certificados_Afiliados.modificar(entidad);
                    str += "Certificado modificado"
                } else {

                    let data = await API.Certificados_Afiliados.alta(entidad);
                    commit("agregar", data)
                    str += `Certificado dado de alta`
                }
                commit("comun/mostrar", str)
                return 0;
            } catch (error) {
                alert(error)
            }
        },
    },
    modules: {
        comun,
    }

}
export default certificadosafiliados;